(function () {
  'use strict';

  // Quick-View: Split Gallery deaktivieren + nur erstes Slide zeigen
  function fixQuickView() {
    const quickAddEl = document.querySelector('product-component#quick-add-modal-content');
    if (!quickAddEl) return;

    const right = quickAddEl.querySelector('[data-split-right]');
    const gallery = quickAddEl.querySelector('.pdp-split-gallery');
    const videoWrapper = quickAddEl.querySelector('[data-video-wrapper]');

    if (right) right.style.display = 'none';
    if (videoWrapper) videoWrapper.style.display = 'none';
    if (gallery) {
      gallery.style.display = 'block';
      gallery.style.gridTemplateColumns = 'unset';
    }

    const slides = quickAddEl.querySelectorAll('slideshow-slide');
    slides.forEach((slide, i) => {
      if (i > 0) slide.style.display = 'none';
    });
  }

  new MutationObserver(() => {
    fixQuickView();
  }).observe(document.body, { childList: true, subtree: true });

  document.addEventListener('click', (e) => {
    if (e.target.closest('quick-add-component, [data-quick-add]')) {
      setTimeout(fixQuickView, 200);
      setTimeout(fixQuickView, 500);
    }
  });

  function initVariantImageSwitcher() {
    const container = document.querySelector('[data-split-right]');
    if (!container || container._pdpSplitInit) return;
    if (container.closest('#quick-add-modal-content')) return;
    container._pdpSplitInit = true;

    const scriptTag = document.querySelector('script[id^="pdp-variant-images"]');
    if (!scriptTag) return;

    let variantImages = {};
    try { variantImages = JSON.parse(scriptTag.textContent); } catch (e) { return; }

    let variantNames = {};
    const namesTag = document.getElementById(scriptTag.id.replace('pdp-variant-images-', 'pdp-variant-names-'));
    if (namesTag) {
      try { variantNames = JSON.parse(namesTag.textContent); } catch (e) { variantNames = {}; }
    }

    function setImage(variantId) {
      if (!variantId || !variantImages[variantId]) return;
      let img = container.querySelector('[data-split-right-img]');
      if (!img) {
        img = document.createElement('img');
        img.setAttribute('data-split-right-img', '');
        img.className = 'pdp-split-gallery__right-image';
        container.appendChild(img);
      }
      img.src = variantImages[variantId];
      const colorName = variantNames[variantId];
      let label = container.querySelector('[data-split-color-label]');
      if (colorName) {
        if (!label) {
          label = document.createElement('span');
          label.className = 'pdp-split-gallery__color-label';
          label.setAttribute('data-split-color-label', '');
          container.appendChild(label);
        }
        label.textContent = colorName;
        label.hidden = false;
      } else if (label) {
        label.hidden = true;
      }
    }

    const isClothing = scriptTag.hasAttribute('data-clothing-gallery');
    const firstId = Object.keys(variantImages)[0];
    const checkedInput = document.querySelector('input[type="radio"][data-variant-id]:checked');
    setImage(isClothing ? scriptTag.dataset.selectedVariantId : checkedInput ? String(checkedInput.dataset.variantId) : firstId);

    document.addEventListener('change', (e) => {
      if (isClothing || !container.isConnected) return;
      if (!e.target.matches('input[type="radio"][data-variant-id]')) return;
      setImage(String(e.target.dataset.variantId));
    });

    const idInput = document.querySelector('input[name="id"]');
    if (idInput) {
      new MutationObserver(() => setImage(idInput.value)).observe(idInput, { attributes: true, attributeFilter: ['value'] });
    }

    function syncHeight() {
      const slideshow = document.querySelector('.pdp-split-gallery__left slideshow-component');
      const right = document.querySelector('[data-split-right]');
      if (!slideshow || !right) return;
      const h = slideshow.getBoundingClientRect().height;
      if (h > 0) right.style.height = h + 'px';
    }
    syncHeight();
    window.addEventListener('resize', syncHeight);
    document.addEventListener('change', () => setTimeout(syncHeight, 50));
  }

  function initVideoOverlay() {
    const wrapper = document.querySelector('[data-video-wrapper]');
    if (!wrapper || wrapper._pdpVideoInit) return;
    if (wrapper.closest('#quick-add-modal-content')) return;
    wrapper._pdpVideoInit = true;

    const slideshow = document.querySelector('.pdp-split-gallery__left slideshow-component');
    if (slideshow && !slideshow.contains(wrapper)) {
      slideshow.style.position = 'relative';
      slideshow.appendChild(wrapper);
    }

    const btn = wrapper.querySelector('[data-video-toggle]');
    const video = wrapper.querySelector('.pdp-video-overlay__video');
    const playIcon = wrapper.querySelector('.pdp-video-icon--play');
    const pauseIcon = wrapper.querySelector('.pdp-video-icon--pause');
    if (!btn || !video) return;

    function stopVideo() {
      video.pause();
      video.classList.remove('is-playing');
      btn.setAttribute('aria-pressed', 'false');
      if (playIcon) playIcon.style.display = '';
      if (pauseIcon) pauseIcon.style.display = 'none';
    }

    btn.addEventListener('click', (e) => {
      e.stopPropagation();
      if (btn.getAttribute('aria-pressed') === 'true') {
        stopVideo();
      } else {
        if (!video.src && video.dataset.src) video.src = video.dataset.src;
        video.play();
        video.classList.add('is-playing');
        btn.setAttribute('aria-pressed', 'true');
        if (playIcon) playIcon.style.display = 'none';
        if (pauseIcon) pauseIcon.style.display = '';
      }
    });

    document.addEventListener('click', (e) => {
      if (!wrapper.contains(e.target)) stopVideo();
    });
  }

  function init() {
    initVariantImageSwitcher();
    initVideoOverlay();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  let initTimer;
  const observer = new MutationObserver(() => {
    clearTimeout(initTimer);
    initTimer = setTimeout(init, 100);
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
